import Vue from 'vue'
import App from './App.vue'
import store from "./store";
import router from "./router";
// import auth from "./firebase/auth";

/* eslint-disable */
// import normalized from "~normalize.css";
import "vue-svg-map/dist/index.css";
import style from "./static/styles/main.scss";
import 'simplebar/dist/simplebar.min.css';
/* eslint-enable */

/* eslint-disable */
// plugins
import scrollLoader from "./plugins/scroll-loader";
import firestore from "./plugins/firestore";
import socket from "./plugins/socket";
import fas from './plugins/fontawesome';
import mask from "./plugins/v-mask";
import simplebar from "./plugins/simplebar";
import flashMessage from "./plugins/vue-flash-message";
import tinymce from "./plugins/tinymce";
/* eslint-enable */

Vue.config.productionTip = false


// auth.signIn()
//   .then(() => {
//     new Vue({
//       store,
//       router,
//       render: h => h(App)
//     }).$mount('#app')
//   })
//   .catch(() => {
//     new Vue({
//       store,
//       router,
//       render: h => h(App)
//     }).$mount('#app')
//   });

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')